import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "search-input" }
const _hoisted_2 = /*#__PURE__*/_createVNode("label", {
  class: "search-input__label",
  for: "search-input"
}, [
  /*#__PURE__*/_createVNode("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor"
  }, [
    /*#__PURE__*/_createVNode("path", {
      "fill-rule": "evenodd",
      d: "M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z",
      "clip-rule": "evenodd"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}, [
  /*#__PURE__*/_createVNode("path", {
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "2",
    d: "M6 18L18 6M6 6l12 12"
  })
], -1)

export function render(_ctx, _cache) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("input", {
      class: "search-input__field",
      type: "text",
      id: "search-input",
      placeholder: "Search styleguide",
      value: _ctx.value,
      ref: "input",
      autocomplete: "off",
      onInput: _cache[1] || (_cache[1] = (...args) => (_ctx.onInput && _ctx.onInput(...args)))
    }, null, 40, ["value"]),
    _withDirectives(_createVNode("button", {
      class: "search-input__clear",
      type: "button",
      onClick: _cache[2] || (_cache[2] = (...args) => (_ctx.onClear && _ctx.onClear(...args))),
      "data-tippy-content": "Clear search"
    }, [
      _hoisted_3
    ], 512), [
      [_vShow, _ctx.value.length > 0]
    ])
  ]))
}

  /**
   * SearchInput component data.
   * @typedef {Object} SearchInputData
   * @property {string} value Value of the input field
   */

  export default {
    name: "search-input",
    emits: {
      // When something is typed into the input field
      "on-input": (value) => typeof value === "string",
    },
    /**
     * @returns {SearchInputData}
     */
    data() {
      return {
        value: "",
      }
    },
    methods: {
      /**
       * Sets focus on the input field,
       */
      focus() {
        this.$refs.input.focus()
      },
      /**
       * Clears the input field.
       */
      clear() {
        this.value = ""
      },
      /**
       * Called when clear button is clicked.
       */
      onClear() {
        this.clear()
        this.focus()
        this.$emit("on-input", this.value)
      },
      /**
       * Called when something is typed into input field.
       */
      onInput(e) {
        this.value = e.target.value
        this.$emit("on-input", this.value)
      },
    },
    mounted() {
      this.focus()
    },
  }
